import React from 'react';
import Stack from '@mui/material/Stack';
import { PRODUCT_HANDLE } from 'utilities/constants';
import { customCardLogo } from 'components/CardConfigurer/configurerFlags';

interface CardLogoProps {
  productHandle: string;
}

const CardLogo: React.FC<CardLogoProps> = ({ productHandle }) => {
  const bgImage = (img: string | undefined) => ({
    backgroundImage: img ? 'url(' + img + ')' : undefined,
  });
  return (
    <Stack
      sx={{
        position: 'absolute',
        zIndex: 999,
        bottom: '19px',
        right: '25px',
        width: {
          xs: '70px',
          md: '130px',
        },
        height: {
          xs: '45px',
          md: productHandle === PRODUCT_HANDLE.MASTER_CARD ? '85px' : '45px',
        },
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        ...bgImage(customCardLogo(productHandle)),
      }}
    ></Stack>
  );
};

export default CardLogo;
